import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { hashString } from '../Helpers/hashString';
import { Person } from '../Models/person';
import { openAlert } from '../Store/AlertSlice';
import { addPersonToSession } from '../firebase/Database/AddPersonToSession';
import { getAllPeople } from '../firebase/Database/GetAllPeople';

interface addPersonToSessionDialogProps {
    sessionId: string;
    open: boolean;
    close: () => void;
}

export const AddPersonToSessionDialog: React.FC<
    addPersonToSessionDialogProps
> = ({ sessionId, open, close }) => {
    const [users, setUsers] = useState<Person[] | null>(null);
    const [selectedUser, setSelectedUser] = useState<string>('');
    const [isLoaded, setIsLoaded] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        getAllPeople()
            .then((res) => {
                setUsers(res);
            })
            .catch((err) => {
                dispatch(
                    openAlert({
                        displayText: 'Problém během načítání lidí',
                        severity: 'error',
                    }),
                );
            })
            .finally(() => {
                setIsLoaded(true);
            });
    }, [dispatch]);

    const onAddHandler = () => {
        if (selectedUser !== '') {
            setIsLoaded(false);
            addPersonToSession(selectedUser, sessionId)
                .then(() => {
                    setSelectedUser('');
                    dispatch(
                        openAlert({
                            displayText: 'Added a user',
                            severity: 'success',
                        }),
                    );
                    close();
                })
                .catch((err) => {
                    dispatch(
                        openAlert({
                            displayText: "Can't add a user",
                            severity: 'error',
                        }),
                    );
                })
                .finally(() => {
                    setIsLoaded(true);
                });
        }
    };

    return (
        <Dialog open={open} onClose={close} fullWidth={true}>
            <DialogTitle>Přihlásit uživatele na lekci</DialogTitle>
            <DialogContent>
                {!isLoaded && <CircularProgress color="secondary" />}
                {isLoaded && users && (
                    <TextField
                        select
                        label="Přidat uživatele"
                        fullWidth={true}
                        sx={{ margin: '10px 0' }}
                        value={selectedUser}
                        onChange={(ev) => setSelectedUser(ev.target.value)}
                    >
                        {users.map((user, index) => {
                            return (
                                <MenuItem
                                    key={index}
                                    value={hashString(user.email)}
                                >
                                    {user.firstName} {user.lastName}
                                </MenuItem>
                            );
                        })}
                    </TextField>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={close}>
                    Zrušit
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onAddHandler}
                >
                    Přidat
                </Button>
            </DialogActions>
        </Dialog>
    );
};
